import {
  Avatar,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Collapse,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
  MenuItem,
  Select,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { green, grey, orange, red } from '@material-ui/core/colors';
import {
  ArrowBack as BackIcon,
  CallMissedOutgoing as CallMissedOutgoingIcon,
  FilterList as FilterListIcon,
  GetApp as GetAppIcon,
  Person as PersonIcon,
  PlayArrow as PlayArrowIcon,
  Star as StarIcon,
  TrendingUp as TrendingUpIcon,
  Replay as ReplayIcon,
} from '@material-ui/icons';
import clsx from 'clsx';
import { add, differenceInSeconds, format, startOfYear } from 'date-fns';
import _ from 'lodash';
import {
  CarBrakeAlert as CarBrakeAlertIcon,
  CarTractionControl as CarTractionControlIcon,
  Speedometer as SpeedometerIcon,
  Steering as SteeringIcon,
} from 'mdi-material-ui';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';
import {
  Bar,
  BarChart,
  Cell,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import {
  FETCH_AGGREGATED_DRIVING_SCORES,
  FETCH_DRIVER_TRIPS_BY_DRIVER_CODE,
  FETCH_DRIVING_SCORES,
  LOAD_AGGREGATED_DRIVING_SCORES,
  UPDATE_AGGREGATED_DRIVING_SCORE_FILTER,
  UPDATE_FILTER_EMERGENCY_EQUIPMENT_USED,
  UPDATE_FILTER_TIME_AGGREGATION,
  UPDATE_SELECTED_AGGREGATED_TRIPS_DRIVER,
} from '../../../actions';
import {
  downloadCSV,
  getVehiclePolls,
  telematicsBoxPollHeaders,
} from '../../../apis/utilities';
import Container from '../../Container';
import { SelectMultiple, TablePagination, Table } from '../../controls';
import { usePrevious } from '../../../hooks';
import { useSnackbar } from '../../Snackbar';

const {
  goodTripScoreThreshold: goodThreshold = 95,
  okTripScoreThreshold: okThreshold = 85,
} = window.config.driverBehaviourOptions;

const { useReducedResourceInformation } = window.config;

function ReplayLink({ entry }) {
  const history = useHistory();

  const handleClick = (identifier) => (event) => {
    event.stopPropagation();

    history.push(`/replay/trips/${identifier}`);
  };

  return entry.tripId ? (
    <IconButton
      title="View"
      size="small"
      aria-label="View"
      onClick={handleClick(entry.tripId)}
    >
      <PlayArrowIcon />
    </IconButton>
  ) : (
    '-'
  );
}

function DownloadPollsLink({ entry }) {
  const handleClick = (imei, startTime, endTime) => async (event) => {
    event.stopPropagation();

    const polls = await getVehiclePolls(imei, startTime, endTime);

    const data = polls.map((poll) => ({
      identificationNumber: entry.identificationNumber,
      registrationNumber: entry.registrationNumber,
      fleetNumber: entry.fleetNumber,
      ...poll,
    }));

    downloadCSV(data, 'Trip Polls.csv', telematicsBoxPollHeaders);
  };

  return (
    <IconButton
      title="Download trip polls"
      size="small"
      onClick={handleClick(entry.imei, entry.startTime, entry.endTime)}
    >
      <GetAppIcon />
    </IconButton>
  );
}

const useStyles = makeStyles((theme) => ({
  itemSection: {
    width: '100%',
    height: 'calc(100vh - 48px)',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  root: {
    padding: theme.spacing(1),
  },
  columns: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'stretch',
  },
  rows: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  card: {
    // margin: theme.spacing(0.5),
    // minWidth: 240,
    flex: 1,
  },
  cardContent: {
    alignItems: 'center',
  },
  chartCard: {
    // margin: theme.spacing(0.5),
    // padding: theme.spacing(4),
    minHeight: 480,
    // minWidth: 240,
    flex: 1,
  },
  score: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  activity: {
    display: 'flex',
    margin: theme.spacing(1),
    alignItems: 'center',
  },
  activityIcon: {
    marginRight: theme.spacing(1),
  },
  flex: {
    flexGrow: 1,
  },
  collapseContainer: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  filterField: {
    width: 144,
  },
  progress: {
    margin: theme.spacing(1),
  },
  tableContainer: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0,
  },
  table: {
    backgroundColor: 'white',
  },
  title: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  radioGroupLabel: {
    paddingRight: theme.spacing(1),
  },
  gridContainer: {
    flexGrow: 1,
    // padding: theme.spacing(1)
  },
  select: {
    paddingBottom: theme.spacing(1),
  },
  formControl: {
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(1),
  },
  listCard: {
    // margin: theme.spacing(0.5),
    // padding: theme.spacing(4),
    height: 767,
    // minWidth: 240,
    // flex: 1
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  speedAvatar: {
    borderWidth: 5,
    borderColor: grey[400],
    borderStyle: 'solid',
    backgroundColor: 'transparent',
    color: 'black',
  },
  groupByField: {
    width: 120,
  },
  highlightListItem: {
    backgroundColor: theme.palette.divider,
  },
  loadingContainer: {
    position: 'relative',
  },
  loadingOverlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(192,192,192,.35)',
    zIndex: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  reloadButton: {
    backgroundColor: 'secondary',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '40%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 'medium',
    borderRadius: theme.spacing(0.5),
  },
  errorText: {
    marginTop: 136,
    top: 0,
    left: 0,
    zIndex: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  replayIcon: {
    marginRight: theme.spacing(1),
  },
}));

function scoreColour(score) {
  if (!score || score === 0) {
    return '#000';
  }

  return score > goodThreshold
    ? green[500]
    : score < okThreshold
    ? red[500]
    : orange[700];
}

const preAreaHeaders = [
  { label: 'Name', key: 'name' },
  { label: 'Collar Number', key: 'collarNumber' },
  { label: 'Role', key: 'role' },
];

const postAreaHeaders = [
  { label: 'Average Score (%)', key: 'averageScore' },
  { label: 'Lowest Score (%)', key: 'lowestScore' },
  { label: 'Highest Score (%)', key: 'highestScore' },
];

function getDriverDownloadHeaders(filterAreas) {
  return preAreaHeaders
    .concat(
      Object.entries(filterAreas).map(([key, $]) => ({
        label: _.startCase(key),
        key,
      }))
    )
    .concat(postAreaHeaders);
}

function formatSeconds(seconds) {
  return `${((seconds || 0) / 3600).toFixed(seconds > 86400 ? 0 : 2)} hours`;
}

const CustomTooltip = ({ active, payload, label }) => {
  if (active) {
    return (
      <div
        className="recharts-default-tooltip"
        style={{
          margin: '0px',
          padding: '10px',
          backgroundColor: 'rgb(255, 255, 255)',
          border: '1px solid rgb(204, 204, 204)',
          whiteSpace: 'nowrap',
        }}
      >
        <p className="recharts-tooltip-label" style={{ margin: '0px' }}>
          {label}
        </p>
        {(payload || []).map(({ name, value }) => (
          <p key={name} style={{ color: scoreColour(value) }}>
            {`${name}: ${_.round(value, 2)}%`}
          </p>
        ))}
      </div>
    );
  }

  return null;
};

const yAxisStep = 10;
const yAxisDomain = [
  (dataMin) => {
    // console.log('min', dataMin);
    if (!isFinite(dataMin)) {
      return dataMin;
    }

    // round dataMin down to nearest yAxisStep
    dataMin =
      Math.floor(Math.max(0, dataMin) / yAxisStep, yAxisStep) * yAxisStep;
    return dataMin === 100 ? 90 : dataMin;
  },
  () => 100,
];

export default function DriverBehaviourDashboard() {
  const aggregatedTripHeaders = [
    { key: 'label', accessor: 'label', label: 'Time', type: 'text' },
    {
      key: 'tripsDistanceMileage',
      label: 'Distance',
      align: 'right',
      accessor: 'tripsDistanceMileage',
      type: 'number',
      format: (value) => `${_.round(value, 2)} miles`,
    },
    {
      key: 'tripsDurationSeconds',
      label: 'Driving',
      align: 'right',
      accessor: 'tripsDurationSeconds',
      type: 'number',
      format: (value) => formatSeconds(value),
    },
    {
      key: 'excessAccelerationRatio',
      label: 'Acceleration',
      align: 'right',
      accessor: 'excessAccelerationRatio',
      type: 'number',
      format: (value) => `${_.round(value * 100, 2)}%`,
    },
    {
      key: 'excessBrakingRatio',
      label: 'Braking',
      align: 'right',
      accessor: 'excessBrakingRatio',
      type: 'number',
      format: (value) => `${_.round(value * 100, 2)}%`,
    },
    {
      key: 'excessCorneringRatio',
      label: 'Cornering',
      accessor: 'excessCorneringRatio',
      type: 'number',
      format: (value) => `${_.round(value * 100, 2)}%`,
    },
    {
      key: 'speedInfractionRatio',
      label: 'Speeding',
      align: 'right',
      accessor: 'speedInfractionRatio',
      type: 'number',
      format: (value) => `${_.round(value * 100, 2)}%`,
    },
    {
      key: 'score',
      label: 'Score',
      align: 'right',
      accessor: 'score',
      type: 'number',
      format: (value) => (
        <span
          style={{
            color: scoreColour(value),
          }}
        >
          {`${_.round(value, 2)}%`}
        </span>
      ),
    },
  ];

  const dateFormat = 'dd/MM/yyyy HH:mm:ss';

  // trip columns
  const individualTripsHeaders = [
    {
      key: 'collarNumber',
      accessor: 'collarNumber',
      label: 'Driver',
      type: 'text',
    },
    {
      key: 'startTime',
      accessor: 'startTime',
      label: 'Start Time',
      type: 'date',
      format: (value) => format(value, dateFormat),
    },
    {
      key: 'endTime',
      accessor: 'endTime',
      label: 'End Time',
      type: 'date',
      format: (value) => format(value, dateFormat),
    },

    {
      key: 'fleetNumber',
      accessor: 'fleetNumber',
      label: 'Fleet Number',
      type: 'text',
    },
    // test { key: 'vehicleImei', accessor: 'vehicleImei', label: 'IMEI'},
    {
      key: 'durationSeconds',
      accessor: 'durationSeconds',
      label: 'Duration',
      align: 'right',
      // format: (value) => shortHumanizer(value * 1000, { largest: 2 }),
      type: 'number',
      format: (value) => formatSeconds(value),
    },
    {
      key: 'mileage',
      accessor: 'mileage',
      label: 'Distance',
      align: 'right',
      type: 'number',
      format: (value) => `${_.round(value, 2)} miles`,
    },
    {
      key: 'score',
      accessor: 'score',
      label: 'Score',
      align: 'right',
      type: 'number',
      format: (value) => (
        <span
          style={{
            color: scoreColour(value),
          }}
        >
          {`${_.round(value, 2)}%`}
        </span>
      ),
    },
    {
      key: 'tripId',
      accessor: 'tripId',
      label: 'View',
      align: 'right',
      type: 'component',
      component: ReplayLink,
    },
    {
      key: 'downloadAccelPolls',
      label: 'Polls',
      type: 'component',
      component: DownloadPollsLink,
      sortable: false,
    },
  ];

  const [driverPage, setDriverPage] = useState(0);
  const [tripsPage, setTripsPage] = useState(0);
  const rowsPerDriverPage = 5;
  const rowsPerTripsPage = 10;

  const [driverOrder, setDriverOrder] = useState('asc');
  const [driverOrderBy, setDriverOrderBy] = useState('Group');

  const [tripOrder, setTripOrder] = useState('asc');
  const [tripOrderBy, setTripOrderBy] = useState('Group');

  function handleChangeDriverPage(_, newPage) {
    setDriverPage(newPage);
  }

  function handleChangeTripsPage(_, newPage) {
    setTripsPage(newPage);
  }

  function handleDriverOrderChange(order) {
    setDriverOrder(order);
  }

  function handleDriverOrderByChange(orderBy) {
    setDriverOrderBy(orderBy);
    setDriverOrder('asc');
  }

  function handleTripOrderChange(order) {
    setTripOrder(order);
  }

  function handleTripOrderByChange(orderBy) {
    setTripOrderBy(orderBy);
    setTripOrder('asc');
  }

  function setDates(startTime, endTime, timeAggregation) {
    if (timeAggregation === 'years') {
      startTime = startOfYear(add(new Date(), { years: -10 }));
      endTime = startOfYear(add(new Date(), { years: 1 }));
    }

    deselectAggregatedTrips();

    dispatch({
      type: UPDATE_FILTER_TIME_AGGREGATION,
      payload: {
        startTime,
        endTime,
        timeAggregation,
      },
    });

    fetchAggregatedDrivingScores(startTime, endTime, timeAggregation);
  }

  function handleBarClick(props) {
    if (isLoading || !props || !props.activePayload) {
      return;
    }

    const { activePayload } = props;
    const { date: selectedStartTime } = activePayload[0].payload;

    if (timeAggregation === 'years') {
      // if the timeAggregation is currently years, drilling in is a year of months
      setDates(
        selectedStartTime,
        add(selectedStartTime, { years: 1 }),
        'months'
      );
    } else if (timeAggregation === 'months') {
      // if the timeAggregation is currently months, drilling in is a month of days
      setDates(
        selectedStartTime,
        add(selectedStartTime, { months: 1 }),
        'days'
      );
    }

    // don't do anything for clicking on a day
  }

  function mergeTrips(vehicleTrips, driverTrips) {
    return vehicleTrips.map((vehicleTrip) => {
      // match on start time
      const vehicleTripStart = new Date(vehicleTrip.startTime);
      const matchingDriverTrip = (driverTrips || []).find((d) => {
        const secondsDifference = differenceInSeconds(
          vehicleTripStart,
          new Date(d.startTime)
        );
        return (
          vehicleTrip.vehicleIdentificationNumber ===
            d.vehicle?.identificationNumber && Math.abs(secondsDifference) < 10
        );
      });

      const tripId = matchingDriverTrip?.identifier;
      const imei = matchingDriverTrip?.vehicle?.telematicsBoxImei;
      const speedPercent =
        vehicleTrip.durationSeconds > 0
          ? 100 *
            ((matchingDriverTrip?.speedingSeconds || 0) /
              vehicleTrip.durationSeconds)
          : 0;
      // a vehicleTrip score already has accel subtracted, now take away speeding %
      const score = vehicleTrip.score - speedPercent;

      return { ...vehicleTrip, tripId, score, imei };
    });
  }

  const dispatch = useDispatch();
  const data = useSelector(
    (state) => state.reports.aggregatedDrivingScores.data,
    _.isEqual
  );
  const isLoading = useSelector(
    (state) => state.reports.aggregatedDrivingScores.isLoading
  );
  const error = useSelector(
    (state) => state.reports.aggregatedDrivingScores.error
  );
  const filter = useSelector(
    (state) => state.reports.aggregatedDrivingScores.filter,
    _.isEqual
  );
  const filterValues = useSelector(
    (state) => state.reports.aggregatedDrivingScores.filterValues,
    _.isEqual
  );

  const individualData = useSelector(
    (state) => state.reports.drivingScores.data
  );
  const individualIsLoading = useSelector(
    (state) => state.reports.drivingScores.isLoading
  );
  const individualError = useSelector(
    (state) => state.reports.drivingScores.error
  );
  const driverTrips = useSelector((state) => state.reports.driverTrips);

  const emergencyEquipmentUsed = useSelector(
    (state) => state.filters.emergencyEquipmentUsed,
    _.isEqual
  );
  const startTime = useSelector(
    (state) => state.reports.aggregatedDrivingScores.startTime,
    _.isEqual
  );
  const endTime = useSelector(
    (state) => state.reports.aggregatedDrivingScores.endTime,
    _.isEqual
  );
  const timeAggregation = useSelector(
    (state) => state.reports.aggregatedDrivingScores.timeAggregation || 'years'
  );

  const selectedDriverCode = useSelector(
    (state) => state.reports.aggregatedDrivingScores.selectedDriverCode
  );
  const selectedDriverTripsKey = useSelector(
    (state) => state.reports.aggregatedDrivingScores.selectedDriverTripsKey
  );

  const [showFilter, setShowFilter] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState();
  const [selectedAggregatedTrips, setSelectedAggregatedTrips] = useState();
  const listRef = useRef();
  const classes = useStyles();
  const snackbar = useSnackbar();

  // aggregated data is split by emergency equipment, values are 0, 1, and 2
  // for no, yes, yes & no. These correspond to the following keys so for example
  // if equipment of yes was selected, index 1 gets the key "statsWithEmergencyEquipment"
  const subTotalKeys = [
    'statsWithoutEmergencyEquipment',
    'statsWithEmergencyEquipment',
    'statsAll',
  ];
  const subTotalIndex =
    emergencyEquipmentUsed < subTotalKeys.length ? emergencyEquipmentUsed : 2;
  const subTotalKey = subTotalKeys[subTotalIndex];

  const totals = data[subTotalKey]?.totals;
  const trend = data[subTotalKey]?.trend;
  const drivers = data[subTotalKey]?.drivers;
  // const trips = data[subTotalKey]?.trips;

  // try to merge the actual trips with the accel summaries
  // i.e. ignition/swipe trips vs ignition only trips
  const individualTrips = selectedAggregatedTrips
    ? mergeTrips(individualData[subTotalKey]?.trips || [], driverTrips)
    : [];

  // try to reselect the driver and the trips if user comes back from replay
  // or they filter
  const [sortedDrivers, setSortedDrivers] = useState([]);
  const previousTrend = usePrevious(trend);
  useEffect(() => {
    if (previousTrend !== trend) {
      const newSortedDrivers = _.orderBy(
        Object.values(drivers),
        'averageScore',
        'desc'
      ).map((driver) => ({ ...driver, ...driver.areas }));
      setSortedDrivers(newSortedDrivers);

      // the driver data have changed but if we selected one, try to reselect
      if (selectedDriverCode) {
        const driverInNewData = drivers[selectedDriverCode];
        if (driverInNewData) {
          setSelectedDriver(driverInNewData);

          // is the time selected for that driver available
          if (selectedDriverTripsKey) {
            const aggregatedTripsInNewDriver = driverInNewData.aggregatedTrips.find(
              (t) => t.startTime.toISOString() === selectedDriverTripsKey
            );
            if (aggregatedTripsInNewDriver) {
              setSelectedAggregatedTrips(aggregatedTripsInNewDriver);
            } else {
              setSelectedAggregatedTrips(undefined);
            }
          }
        } else {
          setSelectedDriver(undefined);
          setSelectedAggregatedTrips(undefined);
        }
      }

      // if this has been loaded we'll have to reset the start, end and timeAgg
    }
  }, [
    trend,
    previousTrend,
    drivers,
    selectedDriverCode,
    selectedDriverTripsKey,
  ]);

  // no need to do this anymore
  // const previousEmergencyEquipment = usePrevious(emergencyEquipmentUsed);
  // useEffect(() => {
  //   if (
  //     previousEmergencyEquipment !== emergencyEquipmentUsed &&
  //     selectedAggregatedTrips
  //   ) {
  //     // refetch officer trips
  //     setSelectedAggregatedTrips({ ...selectedAggregatedTrips });
  //   }
  // }, [
  //   emergencyEquipmentUsed,
  //   previousEmergencyEquipment,
  //   selectedAggregatedTrips,
  // ]);

  const previousSortedDrivers = usePrevious(sortedDrivers);
  useEffect(() => {
    if (previousSortedDrivers && previousSortedDrivers !== sortedDrivers) {
      if (selectedDriverCode) {
        const index = sortedDrivers.findIndex(
          (d) => d.code === selectedDriverCode
        );
        if (index > 0) {
          listRef.current.scrollToItem(index, 'start');
        }
      }
    }
  }, [previousSortedDrivers, selectedDriverCode, sortedDrivers]);

  const trendVsDriver = selectedDriver
    ? trend.map((t) => ({
        date: t.date,
        label: t.label,
        overallAverage: t.Average,
        driverAverage:
          selectedDriver.aggregatedTrips.find((d) => d.label === t.label)
            ?.score || 0,
      }))
    : undefined;

  useEffect(() => {
    if (error || individualError) {
      snackbar.notify('error', error || individualError);
    }
  }, [error, individualError, snackbar]);

  // any time the filters change reload (and refilter)
  const haveData = Object.keys(drivers).length !== 0;
  const prevFilter = usePrevious(filter);
  useEffect(() => {
    if (prevFilter && prevFilter !== filter) {
      dispatch({
        type: LOAD_AGGREGATED_DRIVING_SCORES,
        payload: filter,
      });
    }
  }, [prevFilter, dispatch, filter]);

  // when it starts for the first time, fetch
  useEffect(() => {
    if (!haveData) {
      dispatch({
        type: FETCH_AGGREGATED_DRIVING_SCORES,
        payload: { startTime, endTime, timeAggregation, filter },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleFilterToggle() {
    setShowFilter(!showFilter);
  }

  function handleEmergencyEquipmentUsedChanged({ target: { value } }) {
    dispatch({
      type: UPDATE_FILTER_EMERGENCY_EQUIPMENT_USED,
      payload: parseInt(value),
    });
  }

  function handleFilterFieldChanged(name, value) {
    const newFilter =
      name in filter
        ? {
            ...filter,
            [name]: (value || []).map((value) => value.value),
          }
        : {
            ...filter,
            areas: {
              ...filter.areas,
              [name]: (value || []).map((value) => value.value),
            },
          };

    dispatch({
      type: UPDATE_AGGREGATED_DRIVING_SCORE_FILTER,
      payload: newFilter,
    });
  }

  function getBreadcrumbs() {
    let parts = [];

    if (timeAggregation === 'days') {
      parts = ['yyyy', 'MMM'];
    } else if (timeAggregation === 'months') {
      parts = ['yyyy'];
    }

    return parts.map((part) => (
      <Button
        key={part}
        color="primary"
        disabled={isLoading}
        onClick={() => {
          if (part === 'yyyy') {
            // timeAgg of 'years' will automatically change start and end to last decade...
            setDates(startTime, endTime, 'years');
          } else if (part === 'MMM') {
            setDates(
              startOfYear(startTime),
              add(startOfYear(startTime), { years: 1 }),
              'months'
            );
          }
        }}
      >
        {format(startTime, part)}
      </Button>
    ));
  }

  // just use the day when the year and month are already visible in the breadcrumb
  function tickFormatter(tickItem) {
    if (timeAggregation === 'days' && tickItem) {
      const dayPart = parseInt(tickItem.substring(0, 2));
      if (!isNaN(dayPart)) {
        return dayPart;
      }
    }

    return tickItem;
  }

  const handleClickAggregatedTrips = (row) => {
    !isLoading && setSelectedAggregatedTrips(row);
  };

  const previousSelectedAggregatedTrips = usePrevious(selectedAggregatedTrips);
  useEffect(() => {
    if (
      previousSelectedAggregatedTrips !== selectedAggregatedTrips &&
      selectedAggregatedTrips
    ) {
      dispatch({
        type: UPDATE_SELECTED_AGGREGATED_TRIPS_DRIVER,
        payload: {
          selectedDriverCode: selectedDriver.code,
          selectedDriverTripsKey: selectedAggregatedTrips.startTime.toISOString(),
        },
      });

      // JL perf: I don't use the end date until here
      // so just calculate it here to save a second in the epic
      const start = selectedAggregatedTrips.startTime;
      const end = add(selectedAggregatedTrips.startTime, {
        [timeAggregation]: 1,
      });

      dispatch({
        type: FETCH_DRIVER_TRIPS_BY_DRIVER_CODE,
        payload: {
          startTime: start,
          endTime: end,
          driverCode: selectedDriver.code,
          excludeExempt: true,
        },
      });

      dispatch({
        type: FETCH_DRIVING_SCORES,
        payload: {
          startTime: start,
          endTime: end,
          driverCode: selectedDriver.code,
          // emergencyEquipmentUsed,
          // collarNumber: selectedDriver.collarNumber,
          filter: {
            code: [],
            name: [],
            collarNumber: [],
            role: [],
            areas: {},
          },
          // addDayToEndTime: false,
        },
      });
    }
  }, [
    dispatch,
    // emergencyEquipmentUsed,
    selectedAggregatedTrips,
    previousSelectedAggregatedTrips,
    selectedDriver,
    timeAggregation,
  ]);

  function ScoreColourCell(score, index) {
    return (
      <Cell
        key={`cell-${index}`}
        stroke={scoreColour(score)}
        fill={scoreColour(score)}
        style={{
          cursor: timeAggregation === 'days' ? 'not-allowed' : 'pointer',
        }}
      />
    );
  }

  function deselectAggregatedTrips() {
    setSelectedAggregatedTrips(undefined);

    dispatch({
      type: UPDATE_SELECTED_AGGREGATED_TRIPS_DRIVER,
      payload: {
        selectedDriverCode: selectedDriver?.code,
        selectedDriverTripsKey: undefined,
      },
    });
  }

  function handleSelectedDriverChange(driver) {
    setSelectedDriver(driver);
    setSelectedAggregatedTrips(undefined);

    dispatch({
      type: UPDATE_SELECTED_AGGREGATED_TRIPS_DRIVER,
      payload: {
        selectedDriverCode: driver.code,
        selectedDriverTripsKey: undefined,
      },
    });
  }

  function DriverRow({ data, index, style }) {
    const item = data[index];

    return (
      <ListItem
        dense
        button
        key={index}
        style={style}
        onClick={() => handleSelectedDriverChange(item)}
        className={selectedDriver === item ? classes.highlightListItem : null}
      >
        <ListItemAvatar>
          <Avatar src={item.picture}>
            <PersonIcon />
          </Avatar>
        </ListItemAvatar>
        {useReducedResourceInformation ? (
          <ListItemText primary={item.code} />
        ) : (
          <ListItemText
            primary={item.name}
            secondary={item.collarNumber}
            primaryTypographyProps={{ noWrap: true }}
          />
        )}
        <Typography
          align="right"
          style={{
            color: scoreColour(item.averageScore),
          }}
        >
          {`${_.round(item.averageScore, 2)}%`}
        </Typography>
      </ListItem>
    );
  }

  function fetchAggregatedDrivingScores(startTime, endTime, timeAggregation) {
    dispatch({
      type: FETCH_AGGREGATED_DRIVING_SCORES,
      payload: { startTime, endTime, timeAggregation, filter },
    });
  }

  function showReloadButton() {
    return (
      <Fragment>
        <Typography variant="h6" className={classes.errorText}>
          Network error retrieving data...
        </Typography>
        <IconButton
          className={classes.reloadButton}
          onClick={() =>
            fetchAggregatedDrivingScores(
              startTime,
              endTime,
              timeAggregation,
              filter
            )
          }
        >
          <ReplayIcon className={classes.replayIcon} />
          Click here to try again
        </IconButton>
      </Fragment>
    );
  }

  return (
    <Container title="Driver Behaviour">
      <div className={classes.itemSection}>
        <div className={classes.root}>
          <Helmet>
            <title>IR3 | Driver Behaviour</title>
          </Helmet>
          <Toolbar>
            <Typography variant="subtitle1">Driver Behaviour</Typography>
            <div className={classes.flex} />
            {!useReducedResourceInformation && (
              <React.Fragment>
                <FormLabel component="legend" className={classes.formLabel}>
                  Emergency Equipment
                </FormLabel>
                <FormControl
                  component="fieldset"
                  className={classes.formControl}
                >
                  <Select
                    labelId="workaround" // otherwise it uses rechart's div!!
                    name="emergencyEquipment"
                    value={emergencyEquipmentUsed}
                    onChange={handleEmergencyEquipmentUsedChanged}
                  >
                    <MenuItem value={0}>No</MenuItem>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={2}>Yes & No</MenuItem>
                  </Select>
                </FormControl>
              </React.Fragment>
            )}
            <IconButton
              title={showFilter ? 'Hide filter' : 'Show filter'}
              onClick={() => handleFilterToggle()}
            >
              <FilterListIcon color={showFilter ? 'primary' : 'inherit'} />
            </IconButton>
            <IconButton
              title="Download data"
              disabled={sortedDrivers.length === 0}
              onClick={() =>
                downloadCSV(
                  sortedDrivers,
                  'Driver Scores.csv',
                  getDriverDownloadHeaders(filterValues.areas)
                )
              }
            >
              <GetAppIcon />
            </IconButton>
          </Toolbar>
          <Collapse in={showFilter} timeout="auto">
            <div className={classes.collapseContainer}>
              {useReducedResourceInformation ? (
                <SelectMultiple
                  className={classes.select}
                  fullWidth
                  label="Staff ID"
                  placeholder="Select..."
                  value={filter.code.map((value) => ({
                    label: value,
                    value,
                  }))}
                  onChange={(value) => handleFilterFieldChanged('code', value)}
                  suggestions={filterValues.code.map((value) => ({
                    label: value,
                    value,
                  }))}
                />
              ) : (
                <Fragment>
                  <SelectMultiple
                    className={classes.select}
                    fullWidth
                    label="Name"
                    placeholder="Select..."
                    value={filter.name.map((value) => ({
                      label: value,
                      value,
                    }))}
                    onChange={(value) =>
                      handleFilterFieldChanged('name', value)
                    }
                    suggestions={filterValues.name.map((value) => ({
                      label: value,
                      value,
                    }))}
                  />
                  <SelectMultiple
                    className={classes.select}
                    fullWidth
                    label="Collar Number"
                    placeholder="Select..."
                    value={filter.collarNumber.map((value) => ({
                      label: value,
                      value,
                    }))}
                    onChange={(value) =>
                      handleFilterFieldChanged('collarNumber', value)
                    }
                    suggestions={filterValues.collarNumber.map((value) => ({
                      label: value,
                      value,
                    }))}
                  />
                  <SelectMultiple
                    className={classes.select}
                    fullWidth
                    label="Role"
                    placeholder="Select..."
                    value={filter.role.map((value) => ({
                      label: value,
                      value,
                    }))}
                    onChange={(value) =>
                      handleFilterFieldChanged('role', value)
                    }
                    suggestions={filterValues.role.map((value) => ({
                      label: value,
                      value,
                    }))}
                  />
                </Fragment>
              )}
              {Object.entries(filterValues.areas).map((entry) => {
                return (
                  <SelectMultiple
                    className={classes.select}
                    fullWidth
                    key={entry[0]}
                    label={_.startCase(entry[0])}
                    placeholder="Select..."
                    value={(filter.areas[entry[0]] || []).map((value) => ({
                      label: value,
                      value,
                    }))}
                    onChange={(value) =>
                      handleFilterFieldChanged(entry[0], value)
                    }
                    suggestions={entry[1].map((value) => ({
                      label: value,
                      value,
                    }))}
                  />
                );
              })}
            </div>
          </Collapse>
          <div className={classes.gridContainer}>
            <Grid container spacing={1}>
              <Grid item xs={4} sm={2}>
                <Card className={classes.card}>
                  <CardHeader
                    avatar={
                      <Avatar>
                        <StarIcon />
                      </Avatar>
                    }
                    title="Score"
                  />
                  <CardContent>
                    {/* for quick testing <PollDownloader
                  imei={'357207051341535'}
                  start={moment('2018-05-02T00:33:50.000Z')}
                  end={moment('2018-05-02T01:14:04.000Z')}
                  classes={classes}
                /> */}
                    <Typography
                      component="h1"
                      variant="h4"
                      align="right"
                      style={{
                        color: scoreColour(totals.averageScore),
                      }}
                    >
                      {`${_.round(totals.averageScore, 2)}%`}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={4} sm={2}>
                <Card className={classes.card}>
                  <CardHeader
                    avatar={
                      <Avatar>
                        <SteeringIcon />
                      </Avatar>
                    }
                    title="Driving"
                  />
                  <CardContent>
                    <Typography component="h1" variant="h4" align="right">
                      {formatSeconds(totals.drivingSeconds)}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={4} sm={2}>
                <Card className={classes.card}>
                  <CardHeader
                    avatar={
                      <Avatar>
                        <SpeedometerIcon />
                      </Avatar>
                    }
                    title="Harsh Acceleration"
                  />
                  <CardContent>
                    <Typography component="h1" variant="h4" align="right">
                      {formatSeconds(totals.harshAccelerationSeconds)}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={4} sm={2}>
                <Card className={classes.card}>
                  <CardHeader
                    avatar={
                      <Avatar>
                        <CarBrakeAlertIcon />
                      </Avatar>
                    }
                    title="Harsh Braking"
                  />
                  <CardContent>
                    <Typography component="h1" variant="h4" align="right">
                      {formatSeconds(totals.harshBrakingSeconds)}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={4} sm={2}>
                <Card className={classes.card}>
                  <CardHeader
                    avatar={
                      <Avatar>
                        <CallMissedOutgoingIcon />
                      </Avatar>
                    }
                    title="Harsh Cornering"
                  />
                  <CardContent>
                    <Typography component="h1" variant="h4" align="right">
                      {formatSeconds(totals.harshCorneringSeconds)}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={4} sm={2}>
                <Card className={classes.card}>
                  <CardHeader
                    avatar={<Avatar className={classes.speedAvatar}>60</Avatar>}
                    title="Speeding"
                  />
                  <CardContent>
                    <Typography component="h1" variant="h4" align="right">
                      {formatSeconds(totals.speedInfractionDurationSeconds)}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card className={classes.chartCard}>
                  <CardHeader
                    avatar={
                      <Avatar>
                        <TrendingUpIcon />
                      </Avatar>
                    }
                    title="Score Trend"
                    subheader={<Breadcrumbs>{getBreadcrumbs()}</Breadcrumbs>}
                  />
                  <CardContent className={classes.loadingContainer}>
                    {isLoading && (
                      <div className={classes.loadingOverlay}>
                        <CircularProgress
                          className={classes.progress}
                          size={32}
                          thickness={6}
                        />
                      </div>
                    )}
                    {error || individualError ? (
                      showReloadButton()
                    ) : (
                      <ResponsiveContainer width="100%" height={400}>
                        <BarChart data={trend} onClick={handleBarClick}>
                          <XAxis
                            dataKey="label"
                            tickFormatter={tickFormatter}
                          />
                          {/* <YAxis domain={['auto', 100]}/> */}
                          {/* <YAxis domain={['auto', 100]}/> */}
                          <YAxis domain={yAxisDomain} />
                          <Tooltip
                            content={<CustomTooltip />}
                            formatter={(value) => `${_.round(value, 2)}%`}
                          />
                          <Bar dataKey="Average" name="Average score">
                            {trend.map((entry, index) =>
                              ScoreColourCell(entry.Average, index)
                            )}
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Card className={classes.listCard}>
                  <CardHeader
                    avatar={
                      <Avatar>
                        <PersonIcon />
                      </Avatar>
                    }
                    title="Drivers"
                  />
                  <div style={{ height: 'calc(100% - 72px)' }}>
                    <AutoSizer>
                      {({ width, height }) => (
                        <FixedSizeList
                          ref={listRef}
                          height={height}
                          overscanCount={10}
                          itemData={sortedDrivers}
                          itemCount={sortedDrivers.length}
                          itemSize={56}
                          width={width}
                        >
                          {DriverRow}
                        </FixedSizeList>
                      )}
                    </AutoSizer>
                  </div>
                </Card>
              </Grid>
              <Grid item xs={12} sm={8}>
                {selectedAggregatedTrips ? (
                  <Card>
                    <CardHeader
                      avatar={
                        <IconButton onClick={() => deselectAggregatedTrips()}>
                          <BackIcon />
                        </IconButton>
                      }
                      title={`${selectedAggregatedTrips.label} Trips`}
                    />
                    <CardContent>
                      {individualIsLoading ||
                      (individualTrips.length > 0 &&
                        individualTrips[0].code !== selectedDriver.code) ? (
                        <CircularProgress
                          className={classes.progress}
                          size={16}
                          thickness={6}
                        />
                      ) : (
                        <React.Fragment>
                          <Table
                            data={individualTrips}
                            headers={individualTripsHeaders}
                            defaultPageSize={10}
                            className={clsx(classes.table, '-highlight')}
                            rowsPerPage={rowsPerTripsPage}
                            page={tripsPage}
                            order={tripOrder}
                            orderBy={tripOrderBy}
                            onOrderChange={handleTripOrderChange}
                            onOrderByChange={handleTripOrderByChange}
                          />
                          <TablePagination
                            rowsPerPageOptions={[rowsPerTripsPage]}
                            component="div"
                            count={individualTrips.length}
                            rowsPerPage={rowsPerTripsPage}
                            page={tripsPage}
                            onPageChange={handleChangeTripsPage}
                          />
                        </React.Fragment>
                      )}
                    </CardContent>
                  </Card>
                ) : (
                  <Card className={classes.listCard}>
                    <CardHeader
                      avatar={
                        <Avatar>
                          <CarTractionControlIcon />
                        </Avatar>
                      }
                      title={
                        selectedDriver
                          ? useReducedResourceInformation
                            ? selectedDriver.code
                            : `${selectedDriver.name}, ${selectedDriver.collarNumber}`
                          : 'Behaviour Breakdown'
                      }
                      subheader={<Breadcrumbs>{getBreadcrumbs()}</Breadcrumbs>}
                    />
                    <CardContent className={classes.loadingContainer}>
                      {trendVsDriver && (
                        <React.Fragment>
                          {isLoading ? (
                            <div className={classes.loadingOverlay}>
                              <CircularProgress
                                className={classes.progress}
                                size={32}
                                thickness={6}
                              />
                            </div>
                          ) : (
                            ''
                          )}
                          <ResponsiveContainer width="100%" height={200}>
                            <ComposedChart
                              data={trendVsDriver}
                              onClick={handleBarClick}
                              style={{ cursor: isLoading ? 'wait' : '' }}
                            >
                              <XAxis
                                dataKey="label"
                                tickFormatter={tickFormatter}
                                scale="band"
                              />
                              <YAxis domain={yAxisDomain} />
                              <Tooltip
                                content={<CustomTooltip />}
                                formatter={(value) => `${_.round(value, 2)}%`}
                              />
                              <Bar dataKey="driverAverage" name="Driver score">
                                {trendVsDriver.map((entry, index) =>
                                  ScoreColourCell(entry.driverAverage, index)
                                )}
                              </Bar>
                              <Line
                                dataKey="overallAverage"
                                name="Average score"
                                stroke="rgba(85, 85, 85, .625)"
                                strokeWidth={1}
                                dot={false}
                              />
                            </ComposedChart>
                          </ResponsiveContainer>
                        </React.Fragment>
                      )}
                      {selectedDriver && (
                        <>
                          <Table
                            data={selectedDriver.aggregatedTrips.sort(
                              (a, b) => a.startTime - b.startTime
                            )}
                            headers={aggregatedTripHeaders}
                            defaultPageSize={10}
                            className={clsx(classes.table, '-highlight')}
                            onSelectClick={handleClickAggregatedTrips}
                            selectMode="single"
                            rowsPerPage={rowsPerDriverPage}
                            page={driverPage}
                            order={driverOrder}
                            orderBy={driverOrderBy}
                            onOrderChange={handleDriverOrderChange}
                            onOrderByChange={handleDriverOrderByChange}
                          />
                          <TablePagination
                            rowsPerPageOptions={[rowsPerDriverPage]}
                            component="div"
                            count={selectedDriver.aggregatedTrips.length}
                            rowsPerPage={rowsPerDriverPage}
                            page={driverPage}
                            onPageChange={handleChangeDriverPage}
                          />
                        </>
                      )}
                    </CardContent>
                  </Card>
                )}
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </Container>
  );
}
